import { render, staticRenderFns } from "./fading-scroll.component.vue?vue&type=template&id=ee939526&scoped=true"
import script from "./fading-scroll.component.vue?vue&type=script&lang=ts"
export * from "./fading-scroll.component.vue?vue&type=script&lang=ts"
import style0 from "./fading-scroll.component.vue?vue&type=style&index=0&id=ee939526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee939526",
  null
  
)

export default component.exports